<template>
    <div class="people-list">
        <list-item
            v-for="user in users_list"
            class="flex-table--row--no-padding-y"
			v-bind:class="user.inactive_at ? 'invalid' : ''"
            @click="showUser(user)"
            :key="user.id"
        >
            <template slot="title">
                <div class="people-list--item-title">
                    <h5 class="people-list--item-title-name">{{user.full_name}}</h5>
                    <h6 class="people-list--item-title-email">{{user.email}}</h6>
                </div>
            </template>

            <template slot="center">
                <div class="people-list--item-content">
                    <div v-if="role.name === 'operative' || role.name === 'supervisor'" class="flex-table--header-content-item">
                        <div class="badge badge--sm badge--primary">{{user.jobs.length || '0'}}</div>
                    </div>
                    <div v-if="role.name === 'operative'" class="flex-table--header-content-item">
                        <div class="badge badge--sm badge--positive">{{user.certificates.length}}</div>
                    </div>
                    <div v-if="role.name === 'operative'" class="flex-table--header-content-item">
                        <div class="badge badge--sm badge--negative"  v-bind:class="getExpiredCertificates(user.certificates).length ? 'text-danger' : ''">{{getExpiredCertificates(user.certificates).length}}</div>
                    </div>
                </div>

                <div class="flex-table--header-content-offset">
                    <div v-if="(delete_url && !job_people_role) || job_people_role" class="btn-group">
                        <svg-image
                            :src="'/svg/' + resource_group +'/more.svg'"
                            width="20px"
                            height="25px"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        ></svg-image>
                        <div v-if="!user.inactive_at" class="dropdown-menu dropdown-menu-right">
                            <svg-image
                                :src="'/svg/' + resource_group +'/bin.svg'"
                                width="20px"
                                height="20px"
                                highlight="danger"
                                class="dropdown-item"
                                :auto_hover="true"
                                :spaced="true"
								v-on:click="deleteUser(user)"
                            >
                                <span class="text-danger">{{delete_url && !job_people_role ? 'Delete' : 'Remove'}}</span>
                            </svg-image>
                            <svg-image
                                :src="'/svg/' + resource_group +'/close.svg'"
                                width="20px"
                                height="20px"
                                highlight="danger"
                                class="dropdown-item"
                                :auto_hover="true"
                                :spaced="true"
								v-if="disable_url"
								v-on:click="disableOrActivateUser(user)"
                            >
                                <span class="text-danger">Disable</span>
                            </svg-image>
                        </div>
						<!--User is inactive-->
						<div v-else-if="disable_url" class="dropdown-menu dropdown-menu-right">
							<svg-image
								:src="'/svg/' + resource_group +'/tick.svg'"
								width="20px"
								height="20px"
								highlight="success"
								class="dropdown-item"
								:auto_hover="true"
								:spaced="true"
								v-on:click="disableOrActivateUser(user)"
							>
								<span class="text-danger">Activate</span>
							</svg-image>
						</div>
                    </div>
                </div>
            </template>
        </list-item>

        <div class="row my-2" v-if="!loading && !users_list.length">
            <div class="col-12 text-center">
                <h6>No users found</h6>
            </div>
        </div>

        <div class="row my-2" v-if="loading">
            <div class="col-12 text-center">
				<loader></loader>
            </div>
        </div>

        <div class="row" v-else-if="more">
            <div class="col-12 text-center">
                <a href="javascript:void(0)" class="btn btn-primary my-2" v-on:click="load()">Load more</a>
            </div>
        </div>
    </div>
</template>

<script>
	import ListItem from "../ListComponent/ListItem";
	import Loader from "../general_components/Loader";
    export default {
		name: "RoleList",
        components: {Loader, ListItem},
        props: [
			'role',
			'users',
			'load_url',
            'preloaded',
            'edit_url',
            'delete_url',
			'disable_url',
			'search'
		],

		data(){
			return {
				users_list: [],

				loading: false,
				reload: false,
                job_people_role: false,

				page: 0,
				more: false,
			}
		},

		beforeMount(){
			if (this.users || this.preloaded) {
			    if (this.users) {
			        this.users_list = this.users;
                }
			    else {
			        this.users_list = this.role.users;
			        this.job_people_role = true;
                }
				this.more = false;
			}
			else {
				//let's load the first batch
				this.load();
			}
		},

		methods: {
			load(){
				let _this = this;

				if (_this.loading){
					_this.reload = true;
					return;
				}

				_this.loading = true;

				axios.post(_this.load_url, {
					search: _this.search,
					role_id: _this.role.id,
					page: _this.page,
				})
					.then(function (response){
						_this.loading = false;

						if (_this.reload){
							_this.reload = false;
							_this.users_list = [];
							_this.page = 0;
							_this.load();
						}

						response.data[_this.role.name].forEach(function (user){
							_this.users_list.push(user);
						});

						_this.page = response.data.current_page + 1;
						_this.more = response.data.current_page < response.data.last_page;
					})
					.catch(function (error) {
						_this.loading = false;

						if (_this.reload){
							_this.reload = false;
							_this.load();
						}
					})
			},

            deleteUser(user){
			    if (this.job_people_role){
                    if (!confirm('Are you sure you want to remove ' + user.full_name + ' from this company?'))
                        return;
                }
			    else {
                    if (!confirm('Are you sure you want to delete permanently ' + user.full_name + '?'))
                        return;
                }

			    axios.delete(this.delete_url.replace('?', user.id))
                    .then(() => window.location.reload())
					.catch(error => {
						if (error.response) {
                            Vue.$toast.open({
                                message: error.response.data.message,
                                type: 'error'
                            });
                        }
					});
            },

			disableOrActivateUser(user){
				if (user.inactive_at){
					if (!confirm('Are you sure you want to activate the ' + user.full_name +'\'s account?'))
						return;
				}
				else {
					if (!confirm('Are you sure you want to disable the ' + user.full_name +'\'s account?'))
						return;
				}

				axios.post(this.disable_url.replace('?', user.id))
					.then(() => window.location.reload())
					.catch(() => {
                        Vue.$toast.open({
                            message: 'Something went wrong',
                            type: 'error'
                        });
                    });
			},

            showUser(user){
			    window.location.href = this.edit_url.replace('?', user.id);
            },

            getExpiredCertificates(certificates){
				let expired_certificates = [], date = new Date();

				certificates.forEach(function (certificate) {
					if (Date.parse(certificate.expires_at) < date){
						expired_certificates.push(certificate);
                    }
                });

				return expired_certificates;
            }
		},

		watch: {
			search(){
				this.page = 0;
				this.users_list = [];
				this.load();
			}
		}
	}
</script>
